import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";

import AB_3422 from "./AB_3422";
import Default from "./Default";

const abTests = {
    dev_3422__v2: loadUsualComponent(AB_3422), // 15/01/26 не тестировали еще
};

const Timer = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default Timer;
